import React, { useState } from "react";
import { FC } from "react";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import CheckBoxInput from "../../../components/CheckBoxInput";
import Field from "../../../components/Field";
import { makeStyles } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 14,
  },
  boxCaption: {
    textAlign: "justify",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.25",
    letterSpacing: "normal",
    color: "#a1a4ac",
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  link: {
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: 500,
    color: "#2f80ed",
  },
  label: {
    marginLeft: -20,
    marginTop: 11,
    fontSize: 12,
    fontWeight: "normal",
    color: "#16110d",
  },
  hasError: {
    color: "#F94B40",
    fontWeight: "bold",
  },
}));

interface TermsApprovalProps {
  termsText: string;
}

const TermsApproval: FC<TermsApprovalProps> = ({ termsText }) => {
  const classes = useStyles();
  const [hasTermError, setHasTermsAccepted] = useState("");
  const [isTermAccepted, setIsTermAccepted] = useState(null);

  return (
    <div className={classes.root}>
      <Typography className={classes.boxCaption} component={"pre"}>
        {termsText}
      </Typography>

      <Container disableGutters={true}>
        <Box display="flex">
          <Field
            name="_isTermsAgreed"
            type="checkbox"
            component={(props) => {
              setHasTermsAccepted(props?.meta?.submitError);
              setIsTermAccepted(props?.input?.checked);
              return (
                <CheckBoxInput
                  input={props.input}
                  size="small"
                  defaultColor={
                    hasTermError?.length && !isTermAccepted && "#F94B40"
                  }
                />
              );
            }}
          />

          <Typography
            className={clsx(
              classes.label,
              hasTermError?.length && !isTermAccepted && classes.hasError,
            )}
          >
            By tapping on the checkbox I accept{" "}
            <Link
              href="/terms-and-conditions"
              className={classes.link}
              target="_blank"
            >
              Terms & Conditions.
            </Link>
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default React.memo(TermsApproval);
